import { Loader } from '@/atoms/Loader';
import { useEnhancedRouter } from '@/hooks/useEnhancedRouter';
import { syncTokensFromCookie } from '@/services/auth';
import axiosPrivate from '@/services/axiosPrivate';
import { selectUserData, setAuthChecked, setUserData } from '@/store';
import { ComponentType, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

export default function withAuth<T extends object>(
  Component: ComponentType<T>,
  noRedirect?: boolean,
) {
  return function WithAuth(props: T) {
    const userData = useSelector(selectUserData);
    const dispatch = useDispatch();
    const { replace } = useEnhancedRouter();

    useEffect(() => {
      const fetchUserData = async () => {
        syncTokensFromCookie();

        try {
          const res = await axiosPrivate.get('/user');

          if (!res) {
            dispatch(setAuthChecked(true));
            return;
          }

          if (res.data) {
            dispatch(setUserData(res.data.user));
          }
          dispatch(setAuthChecked(true));
        } catch {
          dispatch(setAuthChecked(true));
          if (noRedirect) return;
          replace('/auth/login');
        }
      };

      fetchUserData();
    }, []);

    if (!userData && !noRedirect) return <Loader fullScreen />;

    return <Component {...props} />;
  };
}
